<template>
  <v-app>
    <AppNavbare />
     <v-main tag="div">
     <router-view></router-view>
     <v-overlay :value="this.$store.state.LogoutLouding" :absolute='true'
     style="position:fixed;height:100vh">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
     </v-main>
  </v-app>
</template>

<script>
import AppNavbare from '@/components/navigation/Navbare';

export default {
  name: 'App',
  components: {
    AppNavbare
  }
};
</script>

<style lang="scss">
 
  /** vuetify error in css */
</style>
